import { render, staticRenderFns } from "./AddClientForm.vue?vue&type=template&id=f918b20a&scoped=true&"
import script from "./AddClientForm.vue?vue&type=script&lang=js&"
export * from "./AddClientForm.vue?vue&type=script&lang=js&"
import style0 from "./AddClientForm.vue?vue&type=style&index=0&id=f918b20a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f918b20a",
  null
  
)

export default component.exports